import React from 'react'
import Navbar from "../main_website/Navbar";
import PlanContact from './PlanContact'
import PlanBanner from './PlanBanner'
import Whatsapp from './Whatsapp';
import Footer from "../main_website/Footer"

const PlanMyTrip = () => {
  return (
    <div>
      <Navbar />
      <PlanBanner/>
     <br /><br />
    <PlanContact/>
     <br /><br />
     <Whatsapp />
     <Footer />
    </div>
  )
}

export default PlanMyTrip
